import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {UserProvider} from './context/UserContext';
import {RoleProvider} from './context/RoleContext';
import {ModalProvider} from 'styled-react-modal';
import i18next from './i18next.config';
import {I18nextProvider} from 'react-i18next';
import {ThemeProvider, useTheme} from './context/ThemeContext';
import {Theme} from '@radix-ui/themes';
import { ChatLoader} from './components/HubSpot';



const ThemedApp = () => {
  const {theme} = useTheme();

  return (
    <Theme appearance={theme} accentColor="violet" panelBackground="solid">
      <RoleProvider>
        <App/>
        {/*enable this to customize*/}
        {/*<ThemePanel/>*/}
      </RoleProvider>
    </Theme>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserProvider>
    <I18nextProvider i18n={i18next}>
      <ModalProvider>
        <ThemeProvider>
        <ChatLoader/>
          <ThemedApp/>
         
        </ThemeProvider>
      </ModalProvider>
    </I18nextProvider>
  </UserProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();